import { render, staticRenderFns } from "./mobile1.vue?vue&type=template&id=996a6e2e&scoped=true&"
import script from "./mobile1.vue?vue&type=script&lang=js&"
export * from "./mobile1.vue?vue&type=script&lang=js&"
import style0 from "./mobile1.vue?vue&type=style&index=0&id=996a6e2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996a6e2e",
  null
  
)

export default component.exports